<template>
  <vs-tabs
    :position="isSmallerScreen ? 'top' : 'left'"
    class="tabs-shadow-none"
    id="profile-tabs"
    :key="isSmallerScreen"
    :value="active_step"
  >
    <vs-tab
      v-can="'view-quality-control-tastings'"
      icon-pack="feather"
      icon="icon-clipboard"
      :label="!isSmallerScreen ? ' Taste Panels' : ''"
    >
      <div class="tab-general md:ml-4 md:mt-0 mt-4 ml-0">
        <TastePanelTable ref="tastePanelTable" />
      </div>
    </vs-tab>
    <vs-tab
      icon-pack="feather"
      icon="icon-users"
      :label="!isSmallerScreen ? 'My Taste Panels' : ''"
    >
      <div class="tab-general md:ml-4 md:mt-0 mt-4 ml-0">
        <MyTastePanels />
      </div>
    </vs-tab>
  </vs-tabs>

  <!-- <div>
    <div class="vx-row">
      <div class="vx-col w-full">
        
        <TastingForm ref="tastingForm" />
      </div>
    </div>
  </div> -->
</template>
<script>
import TastePanelCreate from "@/components/popups/TastePanel/TastePanelCreate.vue";
import TastingGroupCreate from "@/components/popups/TastePanel/TastingGroupCreate.vue";
import TastePanelTable from "./components/TastePanelTable.vue";
import TastingForm from "./components/TastingForm.vue";
import MyTastePanels from "./MyTastePanels.vue";

export default {
  name: "FormTests",
  data() {
    return {};
  },
  components: {
    TastePanelCreate,
    TastingGroupCreate,
    TastePanelTable,
    TastingForm,
    MyTastePanels,
  },

  async mounted() {
    if (this.$route.query.open) {
      await this.$refs.tastingForm.onClickViewTest(this.$route.query.open);
    }
  },
  methods: {},
};
</script>
